import {
  LogDebug,
  LogError,
  LogInfo,
  LogWarning,
} from "../../../../../helpers/logger"
import { GetNewOrderEntry } from "./elementHelpers"
import { MoveOrderEntryToNewIndex } from "./dndElementHelper"
import _ from "lodash"

export function dndQMoveQuestionToQuestionOrder(
  questionOrders,
  currentQuestion, //The questionObject that we are moving
  currentQuestionOrderId, //The id of the questionOrder entry that the question is currently linked to
  overQuestionOrderId, //The questionOrderId that the question is being dragged over
  addAsFirstQuestionInList, //If true, add the question at the end of the group else first
) {
  try {
    //deep copy the list of questionOrders
    let updatedQuestionOrders = _.cloneDeep(questionOrders)

    //Find indexes
    let currentQuestionOrderIndex = updatedQuestionOrders.findIndex(
      (order) => order.id === currentQuestionOrderId,
    )
    let overQuestionOrderIndex = updatedQuestionOrders.findIndex(
      (order) => order.id === overQuestionOrderId,
    )

    if (currentQuestionOrderIndex === -1) {
      LogWarning("Current question order not found")
      return
    }
    if (overQuestionOrderIndex === -1) {
      LogWarning("Over question order not found")
      return
    }

    //Find objects
    let currentQuestionOrder = updatedQuestionOrders[currentQuestionOrderIndex]
    let overQuestionOrder = updatedQuestionOrders[overQuestionOrderIndex]

    if (overQuestionOrderIndex === 0) {
      LogDebug("Dragging over first questionOrder in list")
    }

    if (
      currentQuestionOrderId !== overQuestionOrderId ||
      !currentQuestionOrder.question
    ) {
      //If the question is currently held in a questionGroup, remove it and create a new questionOrder for the question.
      if (currentQuestionOrder.questionGroup) {
        //Remove the question from the questionGroup list
        currentQuestionOrder.questionGroup.questions =
          currentQuestionOrder.questionGroup.questions.filter(
            (question) => question.id !== currentQuestion.id,
          )

        //Add new questionOrder entry
        let newQuestionOrder = GetNewOrderEntry(
          currentQuestion.type,
          updatedQuestionOrders.length + 1,
        )

        newQuestionOrder.question = { ...currentQuestion, orderNumber: 1 }
        //Update the currentQuestionOrderIndex to the new entry and add it to the list
        currentQuestionOrder = newQuestionOrder

        if (addAsFirstQuestionInList) {
          updatedQuestionOrders = [newQuestionOrder, ...updatedQuestionOrders]
        } else {
          updatedQuestionOrders = [...updatedQuestionOrders, newQuestionOrder]
        }
      }

      if (overQuestionOrder) {
        updatedQuestionOrders = MoveOrderEntryToNewIndex(
          updatedQuestionOrders,
          currentQuestionOrder.id,
          overQuestionOrderId,
        )
      }

      return {
        updatedQuestionOrders,
        currentQuestionOrder,
      }
    } else {
      LogInfo("Nothing done")
      return { updatedQuestionOrders, currentQuestionOrder }
    }
  } catch (error) {
    LogError(
      "dndQMoveQuestionToGroup: Unable to move question into questionOrder",
      error,
    )
  }
}

export function dndQMoveQuestionToQuestionGroup(
  questionOrders,
  currentQuestion, //The questionObject that we are moving
  currentQuestionOrderId, //The id of the questionOrder entry that the question is currently linked to
  overQuestionGroupId, //The questionGroupId that the question is being dragged over
  overQuestionId, //The question within the questionGroup
  addAsFirstQuestionInGroup, //If true, add the question at the end of the group else first
) {
  try {
    //deep copy the list of questionOrders
    let updatedQuestionOrders = _.cloneDeep(questionOrders)

    //Find objects
    let currentQuestionOrder = updatedQuestionOrders.find(
      (order) => order.id === currentQuestionOrderId,
    )
    let overQuestionOrder = updatedQuestionOrders.find(
      (order) => order.questionGroup?.id === overQuestionGroupId,
    )

    let overQuestionGroup = overQuestionOrder?.questionGroup

    //Find the current question within the new group
    let overQuestionOrderQuestion = overQuestionGroup?.questions.find(
      (existingQuestion) => existingQuestion.id === currentQuestion.id,
    )

    if (currentQuestionOrder && overQuestionOrder) {
      if (currentQuestionOrder.question) {
        //This is moving from a main questionOrder to a questionGroup, mark the mainstream order as removed.
        currentQuestionOrder.isDeleted = true
      }

      //If this is in a new group, add it in
      if (currentQuestionOrderId !== overQuestionOrder.id) {
        //This is a new group, add the question into the group
        if (!overQuestionOrderQuestion) {
          let newQuestion = _.cloneDeep(currentQuestion)

          //Add question to group
          newQuestion.groupOrder = overQuestionGroup.questions.length + 1

          if (addAsFirstQuestionInGroup) {
            overQuestionGroup.questions = [
              newQuestion,
              ...overQuestionGroup.questions,
            ]
          } else {
            overQuestionGroup.questions = [
              ...overQuestionGroup.questions,
              newQuestion,
            ]
          }
        } else {
          overQuestionOrderQuestion.isActive = true
        }
      }

      //If we are dragging over a question, update the sorting
      if (overQuestionId && overQuestionId !== currentQuestion.id) {
        overQuestionGroup.questions = MoveOrderEntryToNewIndex(
          overQuestionGroup.questions,
          currentQuestion.id,
          overQuestionId,
        )
      }

      return {
        updatedQuestionOrders,
        currentQuestionOrder: overQuestionOrder,
      }
    } else {
      LogWarning(
        "dndQMoveQuestionToQuestionGroup: Unable to trace all questionOrders",
      )

      return undefined
    }
  } catch (error) {
    LogError(
      "dndQMoveQuestionToQuestionGroup: Unable to move question into/within questionGroup",
      error,
    )
  }
}
